import React, { useState, useContext } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Typography,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  Edit as EditIcon,
  Save as SaveIcon,
  Psychology as AIIcon
} from '@mui/icons-material';
import { doc, updateDoc } from 'firebase/firestore';
import  db  from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import { FeedbackContext } from '../contexts/FeedbackContext';

const ArticleEditor = ({ article }) => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState(article?.title || '');
  const [content, setContent] = useState(article?.article?.content || '');
  const [processing, setProcessing] = useState(false);
  const { currentUser } = useAuth();
  const { showFeedback } = useContext(FeedbackContext);

  if (!currentUser?.isAdmin) return null;

  const handleSave = async () => {
    try {
      await updateDoc(doc(db, 'articles', article.id), {
        title: title.trim(),
      // Create proper nested structure
      article: {
        content: content.trim(),
        author: '',
        title: title.trim(),
        // Preserve existing article map fields if any
        ...(article?.article || {}),
      }
      });
      showFeedback('Article updated successfully', 'success');
      setOpen(false);
    } catch (error) {
      console.error('Error updating article:', error);
      showFeedback('Failed to update article', 'error');
    }
  };

  const processWithAI = async () => {
    setProcessing(true);
    try {
      // TODO: Implement AI processing
      // Call your OpenAI function here
      showFeedback('AI processing completed', 'success');
    } catch (error) {
      console.error('Error processing with AI:', error);
      showFeedback('AI processing failed', 'error');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <>
      <Tooltip title="Edit Article">
        <IconButton onClick={() => setOpen(true)} size="small">
          <EditIcon />
        </IconButton>
      </Tooltip>

      <Dialog 
        open={open} 
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Edit Article</DialogTitle>
        <DialogContent>
          <TextField
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            fullWidth
            multiline
            rows={12}
            margin="normal"
            placeholder="Paste the article content here..."
          />
          <Typography variant="caption" color="text.secondary">
            Original URL: <a href={article.link} target="_blank" rel="noopener noreferrer">{article.link}</a>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            startIcon={<AIIcon />}
            onClick={processWithAI}
            disabled={processing || !content}
            color="secondary"
          >
            {processing ? <CircularProgress size={24} /> : 'Process with AI'}
          </Button>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button 
            startIcon={<SaveIcon />}
            onClick={handleSave}
            variant="contained"
            disabled={!title || !content}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ArticleEditor;